import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/messaging/constants';
import type { MessagesResponseApi } from '@/modules/messaging/types';
import type { ApiQueryParameters } from '@/types/utils/parameters';

import { messagingQueryKeys } from './queryKeys';

export const messagesEndpoint = endpoints.messages;

export type MessagesQueryParamsApi = ApiQueryParameters<
  typeof messagesEndpoint
>;

export const useMessagesQuery = (
  { statuses, jobId }: MessagesQueryParamsApi,
  options?: Omit<
    UseQueryOptions<MessagesResponseApi | undefined, unknown>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: messagingQueryKeys.messages(statuses, jobId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(messagesEndpoint, {
        params: {
          query: {
            statuses,
            jobId,
          },
        },
      });

      return data;
    },
    ...options,
  });
};
